module.exports = __webpack_public_path__ + "img/image_safety.0ea70bf0.png";